var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryActive2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_1420_37006)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9126 28.2726C15.5877 28.2726 16.2352 28.0044 16.7125 27.527C17.1899 27.0496 17.4581 26.4022 17.4581 25.7271C17.4581 25.052 17.1899 24.4046 16.7125 23.9272C16.2352 23.4498 15.5877 23.1816 14.9126 23.1816C14.2375 23.1816 13.5901 23.4498 13.1127 23.9272C12.6354 24.4046 12.3672 25.052 12.3672 25.7271C12.3672 26.4022 12.6354 27.0496 13.1127 27.527C13.5901 28.0044 14.2375 28.2726 14.9126 28.2726V28.2726ZM27.6399 28.2726C28.315 28.2726 28.9625 28.0044 29.4398 27.527C29.9172 27.0496 30.1854 26.4022 30.1854 25.7271C30.1854 25.052 29.9172 24.4046 29.4398 23.9272C28.9625 23.4498 28.315 23.1816 27.6399 23.1816C26.9648 23.1816 26.3174 23.4498 25.84 23.9272C25.3626 24.4046 25.0945 25.052 25.0945 25.7271C25.0945 26.4022 25.3626 27.0496 25.84 27.527C26.3174 28.0044 26.9648 28.2726 27.6399 28.2726V28.2726Z",
    stroke: "#E87A46",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5182 25.7275H23.8182V12.4912C23.8182 12.2886 23.7377 12.0944 23.5945 11.9512C23.4513 11.808 23.2571 11.7275 23.0545 11.7275H6M11.9182 25.7275H9.30909C9.20881 25.7275 9.10951 25.7078 9.01686 25.6694C8.92421 25.631 8.84003 25.5748 8.76912 25.5039C8.69821 25.433 8.64196 25.3488 8.60358 25.2561C8.56521 25.1635 8.54545 25.0642 8.54545 24.9639V18.7275",
    stroke: "url(#paint1_linear_1420_37006)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27344 15.5459H12.3643",
    stroke: "#E87A46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8164 15.5459H30.9564C31.104 15.5459 31.2484 15.5887 31.3722 15.6692C31.496 15.7496 31.5938 15.8641 31.6539 15.999L33.932 21.1255C33.9754 21.2229 33.998 21.3282 33.9982 21.4348V24.9641C33.9982 25.0644 33.9785 25.1637 33.9401 25.2563C33.9017 25.349 33.8455 25.4331 33.7746 25.5041C33.7037 25.575 33.6195 25.6312 33.5268 25.6696C33.4342 25.708 33.3349 25.7277 33.2346 25.7277H30.8164M23.8164 25.7277H25.0891",
    stroke: "url(#paint2_linear_1420_37006)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1420_37006",
    x1: 40,
    y1: 20,
    x2: -0.00000136342,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1420_37006",
    x1: 23.8182,
    y1: 18.7275,
    x2: 6,
    y2: 18.7275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1420_37006",
    x1: 33.9982,
    y1: 20.6368,
    x2: 23.8164,
    y2: 20.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1245"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryActive2);
export default __webpack_public_path__ + "static/media/DeliveryActive2.7865f84477f48be0c92609170e2d7450.svg";
export { ForwardRef as ReactComponent };